export const useIframeStore = defineStore('iframeStore', () => {
  const securityStore = useSecurityStore();
  const sessionCookie = useCookie('chat_session_started'); // useCookie returns a ref
  const showChatPopup = ref(false);
  const inputSearchQuery = ref('');
  const nuxtApp = useNuxtApp();
  const config = nuxtApp.$config;
  const iframeLoaded = ref(false);
  const iframeRef = ref<HTMLIFrameElement | null>(null);
  const annonceMentHeight = ref(0)
const currentPageState = useCookie<boolean>('chat_minimise_state', {
  default: () => true
});
  const initIframe = ref(true);
  const  minimiseValue = ref<boolean>(Boolean(currentPageState.value));
  const hasInitialized = ref(false);

 


  onMounted(() => {
     if (currentPageState.value === undefined) {
      minimiseValue.value = true
    }
    watch(sessionCookie, (newVal) => {
      if (String(newVal) === 'true') {
        showChatPopup.value = true;
      }
    }, { immediate: true });

     watch(minimiseValue, (newVal) => {
       if (hasInitialized.value) {
        currentPageState.value = newVal;
      }
  }, { immediate: true });
   
    hasInitialized.value = true;
    handleMiniseAndMaxiseEvent(Boolean(currentPageState.value));
  });
 
  async function openIframe() {
           
    sessionCookie.value = String(true)
    iframeLoaded.value = true;
    showChatPopup.value = true;
  }

  function closeIframe() {
    sessionCookie.value = String(false)
    minimiseValue.value = false
    showChatPopup.value = false;
    iframeLoaded.value = false;
  }
  function updateInputSearchQuery(value='') {
    inputSearchQuery.value = value
  }
  function UpdateMiniseAndMaximiseValue () {
      minimiseValue.value = !minimiseValue.value;
      initIframe.value = false;
  }


  function handleMiniseAndMaxiseEvent(givenValue) {
    minimiseValue.value = givenValue
    postMessageToIframe({
      type: 'minimize_Maxmise',
      data: { value: !givenValue }
    });
  }

  function setIframeRef(el: HTMLIFrameElement) {
    iframeRef.value = el;
  }
  function setIframeLoaded(status: boolean) {
    iframeLoaded.value = status;
  }
  function postMessageToIframe(payload: any) {
    if (iframeLoaded.value && iframeRef.value?.contentWindow) {
      iframeRef.value.contentWindow.postMessage(payload, config.public.chatIframeDomain);
    } else {
      console.warn('Iframe not loaded or missing ref');
    }
  }

  return {
    showChatPopup,
    inputSearchQuery,
    minimiseValue,
    initIframe,
    annonceMentHeight,
    openIframe,
    closeIframe,
    updateInputSearchQuery,
    UpdateMiniseAndMaximiseValue,
    setIframeRef,
    setIframeLoaded,
    postMessageToIframe,
    handleMiniseAndMaxiseEvent
  };
});
